module.exports = __webpack_public_path__ + "img/Demand prediction & forcasting.89d31780.png";